import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

const BotonesSumayResta = ({ index, onClickSuma, onClickResta, onClickElimina, cantidad, atributo, categoria, inventario }) => {
	return (

		< div >
			{
				onClickElimina ?
					<button className="btnCardPedido naranja" onClick={onClickElimina(index)}>
						< FontAwesomeIcon icon={faTrashAlt} />
					</button >
					: null}
			<button className="btnCardPedido" disabled={inventario ? inventario <= cantidad : false} onClick={onClickSuma(index, atributo, categoria)}>+</button>
			<button className="btnCardPedido gris">{cantidad}</button>
			<button className="btnCardPedido" disabled={cantidad <= 1} onClick={onClickResta(index, atributo)}>-</button>
		</div >
	)
};





export default BotonesSumayResta